"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalIntegrationsEnum = void 0;
var ExternalIntegrationsEnum;
(function (ExternalIntegrationsEnum) {
    ExternalIntegrationsEnum["Clever"] = "Clever";
    ExternalIntegrationsEnum["ClassLink"] = "ClassLink";
})(ExternalIntegrationsEnum || (exports.ExternalIntegrationsEnum = ExternalIntegrationsEnum = {}));
